import { render, staticRenderFns } from "./Shake.vue?vue&type=template&id=bd88d914&scoped=true&"
import script from "./Shake.vue?vue&type=script&lang=js&"
export * from "./Shake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd88d914",
  null
  
)

export default component.exports